(() => {
  const script = document.currentScript;
  const assetBase = script?.src ? new URL('.', script.src) : null;

  function createFacade(frame, index) {
    const source = frame.dataset.src;
    if (!source) return null;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'asif-video-facade';
    const title = frame.title || `Einblick ${index + 1}`;
    button.setAttribute(
      'aria-label',
      `${title} abspielen`
    );

    if (assetBase) {
      const image = document.createElement('img');
      image.src = new URL(`spaces-video-${String(index + 1).padStart(2, '0')}.jpg`, assetBase).href;
      image.alt = '';
      image.width = 480;
      image.height = 360;
      image.loading = 'lazy';
      image.decoding = 'async';
      button.appendChild(image);
    }

    const play = document.createElement('span');
    play.className = 'asif-video-facade__play';
    play.setAttribute('aria-hidden', 'true');

    const playIcon = document.createElement('span');
    playIcon.className = 'asif-play-icon';
    play.appendChild(playIcon);
    button.appendChild(play);

    const note = document.createElement('span');
    note.className = 'asif-video-facade__note';
    note.textContent = title;
    button.appendChild(note);

    button.addEventListener('click', () => {
      const transferFocus = document.activeElement === button;
      const separator = source.includes('?') ? '&' : '?';
      frame.src = `${source}${separator}autoplay=1`;
      frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.removeAttribute('frameborder');
      button.replaceWith(frame);
      // Keep keyboard users at the player without an asynchronous focus jump.
      if (transferFocus) frame.focus({ preventScroll: true });
    }, { once: true });

    return button;
  }

  if (customElements.get('asif-spaces-videos')) return;
  customElements.define('asif-spaces-videos', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.slider = this.querySelector('[data-spaces-video-slider]');
      this.previous = this.querySelector('[data-spaces-video-prev]');
      this.next = this.querySelector('[data-spaces-video-next]');
      this.status = this.querySelector('[data-spaces-video-status]');
      if (!this.slider || !this.previous || !this.next) return;
      this.querySelectorAll('iframe[data-src]').forEach((frame, index) => {
        if (frame.src) return;
        const facade = createFacade(frame, index);
        if (facade) frame.replaceWith(facade);
      });
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.slider.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.slider.addEventListener('keydown', (event) => {
        if (event.target !== this.slider) return;
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.slider);
      this.update();
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.resize?.disconnect();
    }
    move(direction) {
      const item = this.slider.querySelector('.video-wrapper');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.slider).columnGap) || 0;
      this.slider.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
      this.previous.disabled = this.slider.scrollLeft <= 2;
      this.next.disabled = this.slider.scrollLeft >= maxScroll - 2;
      const items = [...this.slider.querySelectorAll('.video-wrapper')];
      const bounds = this.slider.getBoundingClientRect();
      const visible = items.map((item, index) => ({ rect: item.getBoundingClientRect(), index }))
        .filter(item => item.rect.right > bounds.left + 20 && item.rect.left < bounds.right - 20);
      if (this.status && visible.length) {
        const first = visible[0].index + 1;
        const last = visible[visible.length - 1].index + 1;
        this.status.textContent = `${first === last ? first : first + '-' + last} / ${items.length}`;
      }
    }
  });
})();
